import { Button, HorizontalRule } from '@snsw/react-component-library';
import styles from './PlantDesignConfirmation.module.scss';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ScrollToTop from '../../../shared/utils/scrollToTop';

import {
  Row,
  Col,
  SectionPage,
  ComponentLoader,
  IconDownload,
  IconNotificationSuccess,
} from '@snsw/react-component-library';
import { NextSteps } from '@onegov/react-component-library';
import { downloadPlantDesignApplicationPDF, cleanPlantDesignPdf } from 'plantDesign/redux/plantDesignPdfLinkSlice';
import { LoadingStates } from 'shared/constants/loadingStates';
import { clearPlantDesignForm } from 'plantItemNew/redux/slices/formSlice';
import { clearPlantDesignLicenceTypes } from 'plantDesign/redux/plantDesignLicenceTypesSlice';
import { validatePaymentCompleted } from 'shared/utils/Validation';

export const PlantDesignConfirmation = (props) => {
  ScrollToTop();

  const passwordlessOidc = useSelector((state) => state.passwordlessOidc);
  const application = useSelector((state) => state.application);
  const pdfLink = useSelector((state) => state.plantDesignPdfLink);

  const [emailSentTo, setEmailSentTo] = useState(sessionStorage['plant_emailAddress']);
  const [refNumber, setRefNumber] = useState(sessionStorage['plant_applicationNo']);
  const [applicationPaid, setApplicationPaid] = useState(sessionStorage['plant_design_paid']);

  const applicationNo = application ? application.applicationNo : null;
  const applicationId = application ? application.applicationId : null;
  const emailAddress = passwordlessOidc?.user?.profile?.email;

  const { pdfData, pdfState } = pdfLink;

  const dispatch = useDispatch();

  const jsonSteps = [
    {
      title: 'Confirmation',
      description:
        'You will get an email with your payment receipt and confirmation that you have submitted your application.',
    },
    {
      title: 'Review',
      description: 'If we need more information, we will contact you.',
    },
    {
      title: 'Registration documents',
      description: 'We will email the registration documents to you once it is finalised',
    },
  ];

  const downloadSummaryPDF = () => {
    dispatch(downloadPlantDesignApplicationPDF(sessionStorage['plant_applicationId']));
  };

  useEffect(() => {
    const script = document.createElement('script');

    script.src = process.env.REACT_APP_QUICK_FEED;
    script.async = true;

    document.body.appendChild(script);

    window.onload = function () {
      window.quickFeed.init({
        placeholder: 'feedbackContainer',
        label: 'How was your online experience today?',
        environment: process.env.REACT_APP_QUICK_FEED_ENVIRONMENT,
        sourceApplication: process.env.REACT_PLANT_DESIGN_SOURCE_APPLICATION,
        commentForThumbsUp: true,
      });
    };

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    const checkApplicationPaid = async (applicationId) => {
      const resp = await validatePaymentCompleted(applicationId);
      const paid = resp.data.isCompleted && resp.data.applicationId == applicationId;

      sessionStorage['plant_design_paid'] = paid;
      setApplicationPaid(paid);
    };

    if (applicationNo != null) {
      sessionStorage['plant_applicationNo'] = applicationNo;
      setRefNumber(applicationNo);
    }

    if (applicationId) {
      sessionStorage['plant_applicationId'] = applicationId;
      checkApplicationPaid(applicationId).catch(console.error);
    }

    if (emailAddress) {
      sessionStorage['plant_emailAddress'] = emailAddress;
      setEmailSentTo(emailAddress);
    }
  }, [applicationNo, applicationId, emailAddress]);

  useEffect(() => {
    if (pdfData && pdfState === LoadingStates.Succeeded) {
      let fileName = `${sessionStorage['plant_applicationNo']}_Application.pdf`;
      const blob = new Blob([pdfData], { type: 'application/octet-stream' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      dispatch(cleanPlantDesignPdf());
    }
  }, [pdfData, pdfState]);

  useEffect(() => {
    dispatch(clearPlantDesignForm());
    dispatch(clearPlantDesignLicenceTypes());
  }, [dispatch]);

  return (
    <>
      {applicationPaid && (
        <div className={styles.paymentSuccess}>
          <Row>
            <Col span={9}>
              <SectionPage>
                <div className={styles.submittedTitle}>
                  <IconNotificationSuccess />
                  <span>Your have submitted your application</span>
                </div>
                <div className={styles.confirmationText}>
                  <p>
                    We will send a confirmation email to
                    {' ' + emailSentTo}.
                  </p>
                  <p>
                    <b>Application number : </b>
                    {refNumber}
                  </p>
                  <p>You can download a copy of your application now.</p>
                </div>
                <Button
                  variant="secondary"
                  onClick={() => {
                    downloadSummaryPDF();
                  }}
                >
                  <IconDownload color="secondaryBlue" /> Download
                </Button>
              </SectionPage>
              <div className={styles.nextSteps}>
                <NextSteps items={jsonSteps} title="Next steps" />
              </div>
              <p>
                If you need to discuss your application contact{' '}
                <a href="https://www.safework.nsw.gov.au/">SafeWork NSW</a> on 13 10 50.
              </p>
            </Col>
          </Row>
        </div>
      )}

      <Row>
        <Col span={9}>
          <HorizontalRule />
          <div id="feedbackContainer" />
        </Col>
      </Row>

      {pdfState === LoadingStates.Loading || !applicationPaid ? (
        <Row>
          <Col span={12}>
            <ComponentLoader fullPage />
          </Col>
        </Row>
      ) : null}
    </>
  );
};
